import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { checkToken, setToken, api } from '../middlewares'
import rootReducer from '../app/redux/reducers'

export default function(initialState){
    const middlewares = [
        checkToken,
        setToken,
        api,
        thunk
    ]

    const store = createStore(
        rootReducer,
        initialState,
        applyMiddleware(...middlewares)
    )

    return store
}


// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js